import {
  Collapse,
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
} from '@mui/material'
import ExpandLess from '@mui/icons-material/ExpandLess'
import ExpandMore from '@mui/icons-material/ExpandMore'
import { useRouter } from 'next/router'
import React, { FC } from 'react'
import { useIntl } from 'react-intl'
import ExperimentsIcon from '../../../components/uielements/icons/ExperimentsIcon'
import { TtoggleDrawerOnMobile } from '../Sidebar'
import { ExperimentCustomers } from './experiment.customers'
import { useStyles } from '../Sidebar.styles'
import { permissionValidation } from '@novafuturltd/shared'

interface Props {
  permissions: string[]
  openDrawer: boolean
  hoverDrawer: boolean
  toggleDrawerOnMobile: TtoggleDrawerOnMobile
  toggleOpen: (open: boolean) => void
}

const ExperimentsSubMenu: FC<Props> = ({
  permissions,
  openDrawer,
  hoverDrawer,
  toggleDrawerOnMobile,
}) => {
  const intl = useIntl()
  const classes = useStyles({ openDrawer, hoverDrawer })
  const { pathname } = useRouter()
  const [open, setOpen] = React.useState(
    pathname.includes('experiments/') || pathname.includes('recommendations?'),
  )
  const handleClick = () => {
    setOpen(!open)
  }

  return permissionValidation(permissions, [
    'clustering_wrapper',
    'recommendations_engine.reports',
  ]) ? (
    <MenuList aria-labelledby="nested-list-subheader" className={classes.root}>
      <MenuItem
        key="experiments"
        data-test="experiments_sidebar_submenu"
        onClick={handleClick}
        className={classes.menuItem}
        selected={
          !openDrawer &&
          !hoverDrawer &&
          (pathname.includes('experiments/') ||
            pathname.includes('recommendations?'))
        }
      >
        <ListItemIcon>
          <ExperimentsIcon />
        </ListItemIcon>
        <ListItemText
          primary={intl.formatMessage({ id: 'sidebar.experiments.title' })}
          hidden={!openDrawer && !hoverDrawer}
        />
        {open ? (
          <ExpandLess
            onClick={() => setOpen(true)}
            className={classes.expandIcon}
          />
        ) : (
          <ExpandMore
            onClick={() => setOpen(true)}
            className={classes.expandIcon}
          />
        )}
      </MenuItem>
      <Collapse in={open} timeout="auto" hidden={!openDrawer && !hoverDrawer}>
        <MenuList disablePadding={true}>
          {permissionValidation(permissions, ['clustering_wrapper']) && (
            <ExperimentCustomers
              pathname={pathname}
              nested={
                openDrawer || hoverDrawer
                  ? classes.nested
                  : classes.nestedClosed
              }
              toggleDrawerOnMobile={toggleDrawerOnMobile}
            />
          )}
        </MenuList>
      </Collapse>
    </MenuList>
  ) : null
}

export default ExperimentsSubMenu
